import RecurrenceExceptionModal from './RecurrenceExceptionModal';

export default RecurrenceExceptionModal;
